import type { HelpFile } from '../../types/help'
import { ValueListDetailTestIds } from '../../../testids/ValueListDetailTestIds'

export const valueListDetailHelp: HelpFile = {
  docPage: '/docs/schema/value-lists',
  texts: {
    [ValueListDetailTestIds.valueListDetailPage]:
      'Anzeigename, Beschreibung, Aktivzustand und Einträge einer Werteliste auf einen Blick.',
    [ValueListDetailTestIds.cardValueListDetails]:
      'Stammdaten der Werteliste: Name, Beschreibung und Aktivzustand.',
    [ValueListDetailTestIds.btnAddEntry]:
      'Neuen Eintrag hinzufügen — erscheint anschließend in Dropdowns und Validierungsregeln.',
    [ValueListDetailTestIds.btnDeleteList]:
      'Werteliste unwiderruflich löschen — referenzierende Felder werden dadurch ungültig.',
    [ValueListDetailTestIds.btnEditList]:
      'Anzeigename, Beschreibung und Aktivzustand der Werteliste bearbeiten.',
    [ValueListDetailTestIds.colActions]: null,
    [ValueListDetailTestIds.colActive]:
      'Aktive Einträge erscheinen als Auswahloptionen; inaktive Einträge sind in neuen Auswahlen ausgeblendet.',
    [ValueListDetailTestIds.colCode]:
      'Stabiler maschinenlesbarer Code, der beim Auswählen des Eintrags gespeichert wird.',
    [ValueListDetailTestIds.colDescription]:
      'Optionale Beschreibung, die Benutzern bei der Auswahl dieses Eintrags angezeigt wird.',
    [ValueListDetailTestIds.colDrag]:
      'Ziehgriff zum Umsortieren dieses Eintrags innerhalb der Liste.',
    [ValueListDetailTestIds.colLabel]: null,
    [ValueListDetailTestIds.entriesEmpty]:
      'Diese Werteliste ist leer. Fügen Sie Einträge hinzu, damit sie in Formularen und Validierung nutzbar ist.',
    [ValueListDetailTestIds.inputEditEntryDescription]:
      'Optionale Beschreibung für diesen Eintrag, die Benutzern bei der Werteauswahl angezeigt wird.',
    [ValueListDetailTestIds.inputEditEntryLabel]:
      'Für Menschen lesbares Label für diesen Eintrag, das in Dropdowns erscheint.',
    [ValueListDetailTestIds.inputEditVlDisplayName]:
      'Für Menschen lesbares Label für diese Werteliste.',
    [ValueListDetailTestIds.inputEditVlDescription]:
      'Optionale Beschreibung, die den Zweck dieser Werteliste erklärt.',
    [ValueListDetailTestIds.inputEntryCode]:
      'Stabiler maschinenlesbarer Code, der beim Auswählen dieses Eintrags gespeichert wird. Kann nach erster Referenz nicht mehr geändert werden.',
    [ValueListDetailTestIds.inputEntryDescription]:
      'Optionale Beschreibung für den neuen Eintrag, die Benutzern bei der Werteauswahl angezeigt wird.',
    [ValueListDetailTestIds.inputEntryLabel]:
      'Für Menschen lesbares Label für den neuen Eintrag, das in Dropdowns erscheint.',
    [ValueListDetailTestIds.switchEditEntryActive]: null,
    [ValueListDetailTestIds.switchEditVlActive]: null,
  },
}
